import ResponsiveController from 'helpers/controllers/ResponsiveController';

const DEFAULT_BREAKPOINTS = {
  mobile: 480,
  tablet: 760,
  laptop: 1020,
  desktop: 1280,
  extra: Infinity,
};

const getSize = () => {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
};

const getPreparedBreakpoints = (data) => Object.entries(data)
  .sort((first, second) => Number(first[1]) - Number(second[1]));

const getCurrentBreakpoint = (width, breakpoints) => getActiveBreakpoints(width, breakpoints)?.[0] ?? null;

export const getActiveBreakpoints = (width, breakpoints) => breakpoints
  .filter(([, breakpointWidth]) => breakpointWidth >= width);

const install = function (Vue) {
  if (this.installed) {
    return;
  }

  const breakpoints = getPreparedBreakpoints(DEFAULT_BREAKPOINTS);

  Vue.prototype.$screen = new Vue({
    data() {
      return {
        ...getSize(),
        breakpoints,
        breakpoint: getCurrentBreakpoint(getSize().width, breakpoints),
      };
    },
  });

  window.addEventListener('resize', () => {
    const size = getSize();

    Vue.set(Vue.prototype.$screen, 'width', size.width);
    Vue.set(Vue.prototype.$screen, 'height', size.height);
    Vue.set(Vue.prototype.$screen, 'breakpoint', getCurrentBreakpoint(size.width, breakpoints));
  });

  Vue.component('responsive-controller', ResponsiveController);

  this.installed = true;
};

export default { install };
